import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'app/store/rootReducer';
import { fetchReplies } from 'features/posts/repliesSlice';
import { getTimeAgo, getTimeToExpiration, renderHTMLSafe } from 'services/posts-service'; 
import renderer, { replaceIPFSVideoLinks } from 'helpers/contentRenderer';  
import ReplyEditorToggle from './ReplyEditorToggle';
import VoteButton from './VoteButton'; 
import ContentEditPostModal from 'features/content/contentModals/ContentEditPostModal';
import { useAuth } from 'helpers/authContext';
import { get_ipfs_usage } from 'services/db-service';
import RewardsButton from './RewardsButton';
import { getReputation } from 'services/dsteem-service';
import { VerifiedIcon } from './VerifiedIcon';
type Props = {
  post: any; 
  onError: (msg: string) => void;
  onLogin: Function; 
  userPlans:any; 
  setLocalReplies:Function; 
  localReplies:any;  
};

const PostReplies = ({ post, onError, onLogin, userPlans,
    localReplies, setLocalReplies, 
    }: Props) => {
    const dispatch = useDispatch(); 
    const [isEditOpen, setIsEditOpen] = useState(false);
    const [replyToEdit, setReplyToEdit] = useState(null);
    const [ipfsAccount, setIpfsAccount] = useState<any>({});
    const { user } = useAuth(); 
    const repliesRedux = useSelector((state: RootState) => state.replies.replies);
    const isLoadingReplies = useSelector((state: RootState) => state.replies.isLoadingReplies); 

    useEffect(() => { 
        setLocalReplies(repliesRedux || []);
    }, [repliesRedux]);
    useEffect(() => {
        (async () => {
            const ipfs = await get_ipfs_usage(`@${user}:speem`); 
            setIpfsAccount(ipfs || []);
        })()
    }, []);
    useEffect(() => {
        if (post && post.author && post.permlink) {
            console.log("Fetching replies"); 
            dispatch(fetchReplies(post.author, post.permlink));
        }
    }, [post?.author, post?.permlink]); 
    const handleNewReply = (newReply) => {
      console.log("Adding reply",newReply); 
      setLocalReplies((prev) => {
        if (newReply.parent_author == post.author && newReply.parent_permlink == post.permlink) {
          return [...prev, newReply];
        } 

        const newArray = [];
        let inserted = false;

        for (const e of prev) {
          newArray.push(e);

          if (
            !inserted &&
            newReply.parent_author === e.author &&
            newReply.parent_permlink === e.permlink
          ) {
            newArray.push(newReply);
            inserted = true; 
          }
        } 
        if (!inserted) {
          newArray.push(newReply);
        }
        return newArray; 
      });
    }; 
    const renderReply = (reply, index) => {
        const depth = reply.depth - post.depth;
        let payoutTimeString = getTimeToExpiration(reply.created); 
        let reputation:any = 0;
        try {
          reputation = (typeof post.author_reputation  == "string") ? `(${getReputation(reply?.author_reputation)})`:`(${reply?.author_reputation.toFixed(0)||0})`;
        } catch (error) {
          
        }
        const plan = userPlans.find(u => u.username === reply.author);  
        let isPlus = plan?.plan_type?.includes("plus") || false;
        return (
        <div key={reply.id} className={`reply-container mt-3 depth-${depth}`}>
            <div className="reply-header ">
            <Link to={`/u/${reply.author}`}>
              <img src={`https://steemitimages.com/u/${reply.author}/avatar`} alt={reply.author} width={40} height={40} style={{ borderRadius: '50%', marginRight: '10px' }} />
            </Link>
            <span><Link to={`/u/${reply.author}`} className={`${reply.root_author == reply.author?"reply-author-name":"color-letters"}`}>@{reply.author} {reputation}</Link> {(isPlus) && (<div className="text-muted d-inline-block"  title='Verified Plus member.' style={{marginRight:"2px", cursor:"pointer"}}><VerifiedIcon size={22} className="color-speem" /> </div> )}</span> · <span className="reply-created text-muted"><Link to={'/p/'+reply.author+'/'+reply.permlink} className='no-color'>{getTimeAgo(reply.created)}</Link></span>
            </div>
            <div className="reply-body body-content mt-2">
            {renderHTMLSafe(replaceIPFSVideoLinks(renderer.render(reply.body)))}
            </div>
            <div className="reply-actions mt-2" data-id={index}>  
                <VoteButton 
                className='post-tools'
                position='left'
                post={reply} 
                onLogin={() => onError("You must log in to vote or reply")} 
                author={reply.author} 
                permlink={reply.permlink} 
                reward_fund={post.reward_fund} 
                median_price={post.median_price} 
                setLocalReplies={setLocalReplies} 
                onNewError={onError}
                /> 
                {/* <span className="btn reply-votes post-tools">
                    <i className="fas fa-dollar"  />
                    {(reply.cashout_time == "1969-12-31T23:59:59" ? parseFloat(reply.total_payout_value):parseFloat(reply.pending_payout_value)).toFixed(3)}
                </span> */}
                <RewardsButton 
                  payoutTimeString={payoutTimeString}
                  post={reply}
                  onNewError={() => console.log("error")}
                  position='left'
                  className='post-tools'
                />
                {reply.author == user && (
                  <button
                    className="btn post-tools"
                    onClick={() => {
                      setReplyToEdit(reply);
                      setIsEditOpen(true);
                    }}
                  >
                    <i className="fas fa-pen" /> Edit
                  </button> 
                )}
                <ReplyEditorToggle
                  depth={1}
                  author={reply.author}
                  permlink={reply.permlink}
                  parent_author={post.author}
                  IpfsAccount={ipfsAccount}
                  parent_permlink={post.permlink}
                  onLogin={onLogin}
                  onNewError={onError}
                  onSuccess={handleNewReply}
                />
            </div> 
            

        </div>
        );
    };

    if (isLoadingReplies) {
        return <div className="text-center mt-3"><span className="spinner dark" /></div>;
    }

    return ( 
        <div className="post-replies-content"> 
            <h3 className="post-video-description-title">{localReplies.length || 0} comments</h3> 
            <ReplyEditorToggle
                depth={1}
                author={post.author}
                permlink={post.permlink}
                parent_author={''}
                parent_permlink={''}
                onNewError={onError}
                onLogin={onLogin}
                IpfsAccount={ipfsAccount}
                onSuccess={handleNewReply}
                isVisible={true}
                buttonText="Comment"
                // buttonClassName="btn btn-primary mb-3"
            />

            <div className="replies">
                {(localReplies && localReplies.length > 0) ? localReplies.map((r, idx) => renderReply(r, idx)): ""}
            </div>

            {replyToEdit && (
              <ContentEditPostModal
                isShowing={isEditOpen}
                hide={() => setIsEditOpen(false)}
                isComment={true}
                title={replyToEdit.title || ""}
                description={replyToEdit.body}
                tags={""} 
                post={replyToEdit}
                onSuccess={(updatedReply) => {
                  setLocalReplies(prev =>
                    prev.map(r => r.permlink === updatedReply.permlink ? updatedReply : r)
                  );
                  setIsEditOpen(false);
                }}
              />
            )}

        </div> 
    );
};

export default PostReplies; 